import { App } from "vue";
import localforage from "localforage";

const dataStoreTitle_v1: string = 'tmi';
const dataStoreTitle_v2: string = 'tmi-prime';
const dataStoreTitle_v3: string = 'tmi-se';
const dataStoreTitle_v4: string = 'tmi-sen';
const dataStoreTitle_v5: string = 'tmi-sent';
const dataStoreTitle_v6: string = 'tmi-senti';
const dataStoreTitle_v7: string = 'tmi-sentie';
const dataStoreTitle_v8: string = 'tmi-sentien';
const dataStoreTitle_v9: string = 'sentient';
const dataStoreTitle_v10: string = 'sentient-';
const dataStoreTitle_v11: string = 'sentient-v';
const dataStoreTitle_v12: string = 'sentient-v1';
const dataStoreTitle_v13: string = 'sentient-v1.';
const dataStoreTitle_v14: string = 'sentient-v10';
const dataStoreTitle_v15: string = 'sentient-v101';
const dataStoreTitle_v16: string = 'sentient-v1010';
const dataStoreTitle_v17: string = 'sentient-v10101';
const dataStoreTitle_v18: string = 'sentient-v101010';
const dataStoreTitle_v19: string = 'sentient-v1010101';
const dataStoreTitle_v20: string = 'sentient-1010101';
const dataStoreTitle_v21: string = 'sentient-010101';
const dataStoreTitle_v22: string = 'sentient-10101';
const dataStoreTitle_v23: string = 'sentient-0101';
const dataStoreTitle_v24: string = 'sentient-101';
const dataStoreTitle_v25: string = 'sentient-01';
const dataStoreTitle_v26: string = 'sentient-1';
const dataStoreTitle_v27: string = 'sentient-';
const dataStoreTitle_v28: string = 'sentien';
const dataStoreTitle_v29: string = 'sentie';
const dataStoreTitle_v30: string = 'senti';
const dataStoreTitle_v31: string = 'sent';
const dataStoreTitle_v32: string = 'sen';
const dataStoreTitle_v33: string = 'se';
const dataStoreTitle_v34: string = 's';

const dataStoreVersion: number = 1;

const currentDatabaseName = dataStoreTitle_v34;
export async function resetCurrentCachedData() {
    await localforage.dropInstance( {
        name: currentDatabaseName
    } );

    localStorage.clear();
    await LocalForagePlugin.initialize();
}

let articles: LocalForage;
let authors: LocalForage;
let bonusReports: LocalForage;
let categories: LocalForage;
let courses: LocalForage;
let industrySectors: LocalForage;
let products: LocalForage;
let sectors: LocalForage;
let sectorHistory: LocalForage;
let simplePages: LocalForage;
let syncState: LocalForage;
let tags: LocalForage;
let tickers: LocalForage;
let tradeAlerts: LocalForage;
let webinars: LocalForage;

let legacyCleanupDone = false;

const legacyDatabaseNames = [
    dataStoreTitle_v1, dataStoreTitle_v2, dataStoreTitle_v3, dataStoreTitle_v4,
    dataStoreTitle_v5, dataStoreTitle_v6, dataStoreTitle_v7, dataStoreTitle_v8,
    dataStoreTitle_v9, dataStoreTitle_v10, dataStoreTitle_v11, dataStoreTitle_v12,
    dataStoreTitle_v13, dataStoreTitle_v14, dataStoreTitle_v15, dataStoreTitle_v16,
    dataStoreTitle_v17, dataStoreTitle_v18, dataStoreTitle_v19, dataStoreTitle_v20,
    dataStoreTitle_v21, dataStoreTitle_v22, dataStoreTitle_v23, dataStoreTitle_v24,
    dataStoreTitle_v25, dataStoreTitle_v26, dataStoreTitle_v27, dataStoreTitle_v28,
    dataStoreTitle_v29, dataStoreTitle_v30, dataStoreTitle_v31, dataStoreTitle_v32,
    dataStoreTitle_v33
];

const LocalForagePlugin = {
    install( _: App< Element > ) {
        this.initialize();
    },

    initialize(): Promise< void[] > {
        if ( !legacyCleanupDone ) {
            legacyCleanupDone = true;
            for ( const name of legacyDatabaseNames ) {
                localforage.dropInstance( { name } ).then();
            }
        }

        articles = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'articles', // Should be alphanumeric, with underscores.
            description: 'The collection of all subscription-based articles'
        } );

        authors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'authors', // Should be alphanumeric, with underscores.
            description: 'The collection of all authors'
        } );

        bonusReports = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'reports', // Should be alphanumeric, with underscores.
            description: 'The collection of all product-based bonus reports'
        } );

        categories = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'categories', // Should be alphanumeric, with underscores.
            description: 'The collection of all categories'
        } );

        courses = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'courses', // Should be alphanumeric, with underscores.
            description: 'The collection of all educational courses'
        } );

        industrySectors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'industry', // Should be alphanumeric, with underscores.
            description: 'The collection of all industry sectors'
        } );

        products = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'products', // Should be alphanumeric, with underscores.
            description: 'The collection of all defined product offerings'
        } );

        sectors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'sectors', // Should be alphanumeric, with underscores.
            description: 'The collection of all configured sectors'
        } );

        sectorHistory = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'history', // Should be alphanumeric, with underscores.
            description: 'The collection of all sector stats'
        } );

        simplePages = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'pages', // Should be alphanumeric, with underscores.
            description: 'The collection of all non-interactive html page content items'
        } );

        syncState = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'sync_state', // Should be alphanumeric, with underscores.
            description: 'The collection of all current syncing metrics'
        } );

        tags = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'tags', // Should be alphanumeric, with underscores.
            description: 'The collection of all tags'
        } );

        tickers = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'tickers', // Should be alphanumeric, with underscores.
            description: 'The collection of all searchable tickers'
        } );

        tradeAlerts = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'alerts', // Should be alphanumeric, with underscores.
            description: 'The collection of all trade alerts authorized for user'
        } );

        webinars = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'webinars', // Should be alphanumeric, with underscores.
            description: 'The collection of all webinars authorized for user'
        } );

        return Promise.all( [
            articles.ready(),
            authors.ready(),
            bonusReports.ready(),
            categories.ready(),
            courses.ready(),
            industrySectors.ready(),
            products.ready(),
            sectors.ready(),
            sectorHistory.ready(),
            simplePages.ready(),
            syncState.ready(),
            tags.ready(),
            tickers.ready(),
            tradeAlerts.ready(),
            webinars.ready()
        ] );
    }
}

export default LocalForagePlugin;
export {
    articles,
    authors,
    bonusReports,
    categories,
    courses,
    industrySectors,
    products,
    sectors,
    sectorHistory,
    simplePages,
    syncState,
    tags,
    tickers,
    tradeAlerts,
    webinars
};
